var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('v-layout',[_c('v-flex',{attrs:{"md12":""}},[_c('datos-socioeconomicos')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/pages/information/SocioeconomicaPage.vue?vue&type=template&id=f551f5fa&scoped=true&
// module id = 653
// module chunks = 5